<template>
  <b-form @submit.prevent>
    <b-row class="mt-2">
      <b-col
        cols="12"
        class="text-center"
      >
        <h4>Ha seleccionado la exportación de los datos.</h4>
        <h5 class="text-danger">
          Este proceso puede tardar unos minutos
        </h5>
      </b-col>

      <!-- btn centered actions-->
      <b-col class="text-center mt-2">
        <b-button
          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
          type="reset"
          variant="outline-secondary"
          @click="close"
        >
          Cancelar
        </b-button>
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          type="submit"
          variant="primary"
          class="ml-4"
          :disabled="loading"
          @click="exportItem"
        >
          <b-spinner
            v-if="loading"
            small
          />
          {{ loading ? 'Procesando...' : 'Exportar' }}
        </b-button>
      </b-col>
    </b-row>
  </b-form>
</template>

<script>
import {
  BForm, BRow, BCol,
  BButton, BSpinner,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BButton,
    BSpinner,
  },
  directives: {
    Ripple,
  },
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  methods: {
    exportItem() {
      this.$emit('export')
    },
    close() {
      this.$emit('close')
    },
  },
}
</script>
